import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { UsuarioModel } from '../models/UsuarioModel';

@Injectable()
export class UsuarioService {
  usuarioAtual: UsuarioModel;
  dadosUsuario: any;
  subject = new Subject<any>();
  usuarioSetado: Subject<any> = new Subject<any>();
  idsGrupoJurisdicionado: any = [
    "Jurisdicionado - AGORA",
    "CGE - AGORA",
    "TCE Consulta - AGORA",
    "Dirigente Máximo - AGORA"
  ];
  isJur: any = true;
  isPCASubmetida: boolean = false;
  entidade: any = '';
  profileIndex: number;

  constructor(public http: HttpClient) {
  }

  setUsuario(usuarioInfo = null) {
    let logado: boolean = false;

    if (usuarioInfo != null) {
      this.usuarioAtual = new UsuarioModel(usuarioInfo);
      logado = true;
    }
    else {
      this.usuarioAtual = new UsuarioModel();
    }

    this.dadosUsuario = { usr: this.usuarioAtual, logado: logado, entidade: this.getEntidade(), perfil: "" };

    if (this.dadosUsuario)
      this.usuarioSetado.next(this.dadosUsuario);
  }

  setToken(token) {
    this.usuarioAtual.token = token;
  }

  setIsJur(jur) {
    this.isJur = jur;
  }

  getIsJur() {
    return this.isJur;
  }

  getUsuario(): Observable<any> {
    return this.usuarioSetado.asObservable();
  }

  getGrupoJurisdicionado() {
    return this.idsGrupoJurisdicionado;
  }

  obtemUsuario() {
    return this.usuarioAtual;
  }

  obterDadosUsuario() {
    return this.dadosUsuario;
  }

  redirecionarHome(dadosUsuario) {
    if (dadosUsuario)
      this.usuarioSetado.next(dadosUsuario);
  }

  getEntidade() {
    return this.entidade;
  }

  setEntidade(entidade: any) {
    this.entidade = entidade;
  }

  isCGE(isPCASubmetida?: boolean) {

    if (isPCASubmetida !== undefined) {
      this.isPCASubmetida = isPCASubmetida;
    }

    let checkGrupoCGE = false;
    let checkEntidadeCGE = false;

    this.obtemUsuario().dadosUsuario.forEach(element => {
      // if (element.nomeGrupo === 'CGE - AGORA' || element.nomeGrupo === 'TCE Consulta - AGORA') {
      //   checkGrupoCGE = true;
      // }
      if (element.entidade != 'CONTROLADORIA E OUVIDORIA GERAL') {
        checkEntidadeCGE = true;
      }
    });

    if ((this.obterDadosUsuario().perfil.indexOf("CGE") !== -1) || (this.obterDadosUsuario().perfil.indexOf("TCE") !== -1)) {
      checkGrupoCGE = true;
    }

    if (checkGrupoCGE && checkEntidadeCGE) {
      return true;
    } else if (this.isPCASubmetida) {
      return true;
    } else {
      return false;
    }
  }

  isJurisdicionado(index?: number) {

    if (!this.profileIndex && index) {
      this.profileIndex = index;
    } else if (!this.profileIndex && !index) {
      this.profileIndex = 0;
    }

    if (this.usuarioAtual.dadosUsuario != undefined && this.usuarioAtual.dadosUsuario != null && this.usuarioAtual.dadosUsuario.length > 0) {
      const result = this.idsGrupoJurisdicionado.indexOf(this.usuarioAtual.dadosUsuario[this.profileIndex].nomeGrupo) != -1;

      return result;
    } else {
      return false;
    }
  }


  getPerfis() {

    let multiplo = [];

    this.obtemUsuario().dadosUsuario.forEach(element => {
      if (multiplo.indexOf(element.nomeGrupo) === -1) {
        multiplo.push(element.nomeGrupo);
      }
    });

    return multiplo;
  }
}



// WEBPACK FOOTER //
// ./src/providers/usuario-service.ts